<div class="container">
  <div class="container-inventory">
    <div class="header">
      <h1 class="title">{{'SHIPPING_COST' | translate}}</h1>
    </div>

    <div class="loading" *ngIf="loading">
      <div class="spinner-border" role="status"></div>
    </div>

    <div class="form-card">
      <div class="label">
        <div class="label-group">
          <i class="feather" data-feather="info"></i>
          <strong>{{'SHIPPING_COST' | translate}}</strong>
        </div>

        <div class="label-edit">
          <a class="edit-link" (click)="addNewShippingRow()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 1024 1024">
              <path fill="#ea803f"
                d="M512 0C229.232 0 0 229.232 0 512c0 282.784 229.232 512 512 512c282.784 0 512-229.216 512-512C1024 229.232 794.784 0 512 0m0 961.008c-247.024 0-448-201.984-448-449.01c0-247.024 200.976-448 448-448s448 200.977 448 448s-200.976 449.01-448 449.01M736 480H544V288c0-17.664-14.336-32-32-32s-32 14.336-32 32v192H288c-17.664 0-32 14.336-32 32s14.336 32 32 32h192v192c0 17.664 14.336 32 32 32s32-14.336 32-32V544h192c17.664 0 32-14.336 32-32s-14.336-32-32-32" />
            </svg>
          </a>

          <a class="edit-link" [ngClass]="{'visually-hidden': isEditingGeneral == false}"
            (click)="switchCancelEditingAll()">
            <i class="feather-cancel" data-feather="x-circle"></i>
          </a>
        </div>
      </div>

      <div class="info-container row align-items-center"
        *ngFor="let shipping of shippingCosts; let i = index; trackBy: trackByIndex">
        <div class="data-container col-md-4">
          <label class="data-label">{{'TYPE_SHIPPING' | translate}}</label>
          <output class="data-output" *ngIf="!isEditing(shipping.id)">
            {{ shipping.type }}
          </output>
          <input class="form-control" *ngIf="isEditing(shipping.id)" [(ngModel)]="shipping.type" />
        </div>

        <div class="data-container col-md-4">
          <label class="data-label">{{'SHIPPING_COST' | translate}}</label>
          <output class="data-output" *ngIf="!isEditing(shipping.id)">
            {{ shipping.cost }}
          </output>
          <input class="form-control" *ngIf="isEditing(shipping.id)" type="number" [(ngModel)]="shipping.cost" />
        </div>

        <div class="col-md-4 d-flex align-items-center gap-4 pt-4">
          <div class="label-edit" *ngIf="!isEditing(shipping.id)">
            <a class="edit-link" (click)="startEditing(shipping.id)">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="21.333333333333332" viewBox="0 0 576 512">
                <path fill="#ea803f"
                  d="m402.3 344.9l32-32c5-5 13.7-1.5 13.7 5.7V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h273.5c7.1 0 10.7 8.6 5.7 13.7l-32 32c-1.5 1.5-3.5 2.3-5.7 2.3H48v352h352V350.5c0-2.1.8-4.1 2.3-5.6m156.6-201.8L296.3 405.7l-90.4 10c-26.2 2.9-48.5-19.2-45.6-45.6l10-90.4L432.9 17.1c22.9-22.9 59.9-22.9 82.7 0l43.2 43.2c22.9 22.9 22.9 60 .1 82.8M460.1 174L402 115.9L216.2 301.8l-7.3 65.3l65.3-7.3zm64.8-79.7l-43.2-43.2c-4.1-4.1-10.8-4.1-14.8 0L436 82l58.1 58.1l30.9-30.9c4-4.2 4-10.8-.1-14.9" />
              </svg>
            </a>
          </div>

          <div class="label-edit" *ngIf="!isEditing(shipping.id)">
            <a class="edit-link" (click)="removeShippingCost(shipping.id)">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path fill="#e11d48"
                  d="M7 4a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2h4a1 1 0 1 1 0 2h-1.069l-.867 12.142A2 2 0 0 1 17.069 22H6.93a2 2 0 0 1-1.995-1.858L4.07 8H3a1 1 0 0 1 0-2h4zm2 2h6V4H9zM6.074 8l.857 12H17.07l.857-12zM10 10a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1m4 0a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1" />
              </svg>
            </a>
          </div>

          <div class="button-container" *ngIf="isEditing(shipping.id)">
            <button *ngIf="isEditing(shipping.id)" class="primary-btn submit-btn"
              (click)="updateShippingCosts(shipping)">
              {{'SAVE' | translate}}
            </button>
            <button class="btn btn-primary remove-btn" (click)="cancelEditing()">{{'CANCEL' | translate}}</button>
          </div>
        </div>
      </div>

      <div class="info-container row align-items-center" *ngFor="let row of newShippingRows; let i = index">
        <div class="data-container col-md-4">
          <label class="data-label">{{'TYPE_SHIPPING' | translate}}</label>
          <input class="form-control" [(ngModel)]="row.type" placeholder="Ej. Express" />
        </div>

        <div class="data-container col-md-4">
          <label class="data-label">{{'SHIPPING_COST' | translate}}</label>
          <input class="form-control" type="number" [(ngModel)]="row.cost" placeholder="Ej. 1000" />
        </div>

        <div class="col-md-4 d-flex align-items-center gap-4 pt-4">
          <button class="primary-btn submit-btn" (click)="createShippingCosts(row, i)">
            {{'SAVE' | translate }}
          </button>
          <button class="btn btn-primary remove-btn" (click)="cancelNewShippingRow(i)">
            {{'CANCEL' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal client-confirm-modal" id="successShippingCostsModal" tabindex="-1">
  <div class="modal-dialog client-modal-dialog" role="document">
    <div class="modal-content client-modal-content">
      <div class="modal-body client-modal-body">
        <h3 class="text-center">{{'SUCCESS' | translate}}</h3>
        <p class="text-center">{{'SHIPPING_COST_UPDATE' | translate}}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{'CLOSE' | translate}}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal error-confirm-modal fade" id="errorShippingCostsModal" tabindex="-1">
  <div class="modal-dialog error-modal-dialog" role="document">
    <div class="modal-content error-modal-content">
      <div class="modal-body error-modal-body">
        <h3 class="text-center">{{'ERROR' | translate}}</h3>
        <p class="text-center">{{'ERROR_UPDATE_SHIPPING_COST' | translate}}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{'CLOSE' | translate}}</button>
      </div>
    </div>
  </div>
</div>


<div class="modal client-confirm-modal" id="successCreateShippingModal" tabindex="-1">
  <div class="modal-dialog client-modal-dialog" role="document">
    <div class="modal-content client-modal-content">
      <div class="modal-body client-modal-body">
        <h3 class="text-center">{{'SUCCESS' | translate}}</h3>
        <p class="text-center">{{'SHIPPING_COST_CREATE' | translate}}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{'CLOSE' | translate}}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal error-confirm-modal fade" id="errorCreateShippingModal" tabindex="-1">
  <div class="modal-dialog error-modal-dialog" role="document">
    <div class="modal-content error-modal-content">
      <div class="modal-body error-modal-body">
        <h3 class="text-center">{{'ERROR' | translate}}</h3>
        <p class="text-center">{{'ERROR_CREATE_SHIPPING_COST' | translate}}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{'CLOSE' | translate}}</button>
      </div>
    </div>
  </div>
</div>


<div class="modal client-confirm-modal" id="successDeleteShippingCostsModal" tabindex="-1">
  <div class="modal-dialog client-modal-dialog" role="document">
    <div class="modal-content client-modal-content">
      <div class="modal-body client-modal-body">
        <h3 class="text-center">{{'SUCCESS' | translate}}</h3>
        <p class="text-center">{{'SHIPPING_COST_DELETE' | translate}}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{'CLOSE' | translate}}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal error-confirm-modal fade" id="errorDeleteShippingModal" tabindex="-1">
  <div class="modal-dialog error-modal-dialog" role="document">
    <div class="modal-content error-modal-content">
      <div class="modal-body error-modal-body">
        <h3 class="text-center">{{'ERROR' | translate}}</h3>
        <p class="text-center">{{'ERROR_DELETE_SHIPPING_COST' | translate}}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{'CLOSE' | translate}}</button>
      </div>
    </div>
  </div>
</div>
